import {ComponentProps} from "react";

import {v5Pages} from "../../src/components/_common/_constants";
import {CarbonEnvName, CarbonEnvs} from "../../src/constants/urls";
import GetCareSlugOg, {
  propsValidator as getCarePropsValidator,
} from "../../src/page-containers/get-care/ogimage";
import DefaultOg, {
  propsValidator as defaultPropsValidator,
} from "../../src/page-containers/index/defaultOg";
import {getRootUrlFromCarbonHost} from "../../src/utils/urls";

export type PropsValidator = (props: unknown) => boolean;

export const OgPathMap = {
  [v5Pages.getCareSlug]: {
    Component: GetCareSlugOg,
    propsValidator: getCarePropsValidator,
  },
  [v5Pages.home]: {
    Component: DefaultOg,
    propsValidator: defaultPropsValidator,
  },
} as const;

export const isDefinedOgPath = (path: unknown): path is DefinedOgPath =>
  typeof path === "string" && path in OgPathMap;

export const isValidPathAndProps = (path: unknown, props: unknown): boolean =>
  isDefinedOgPath(path) && OgPathMap[path].propsValidator(props);

export type DefinedOgPath = keyof typeof OgPathMap;
export type OgProps<T extends DefinedOgPath> = ComponentProps<typeof OgPathMap[T]["Component"]>;

export type OgPathPropsPair = {
  path: DefinedOgPath;
  props: OgProps<DefinedOgPath>;
};

export const getOgImagePath = (
  path: DefinedOgPath,
  props: OgProps<typeof path>,
  host: typeof CarbonEnvs[CarbonEnvName],
): string => {
  const base = getRootUrlFromCarbonHost(host);
  const route = "/api/og";
  const query = new URLSearchParams({
    path: encodeURIComponent(path),
    props: encodeURIComponent(JSON.stringify(props)),
  });
  return `${base}${route}?${query}`;
};
